import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { useEffect, useRef } from 'react';


/**
 * @author IKlapouch
 * 01/17/2021
 */

export const DialogConformationGeneric = (props) => {
    const { t } = useTranslation();
    const { open, handleClose, message, translateMessage, maxWidth } = props;
    

    function handleKeyPress( event ) {
        if(typeof props.onKeyPress === 'function') {
            props.onKeyPress(event);
        }else if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            handleClose(true)
        }
    }

    return (
        <Dialog
            onKeyPress={handleKeyPress}
            open={open}
            onClose={() => handleClose(false)}
            fullWidth
            style={props.style}
            maxWidth={maxWidth || 'md'}
        >

            <DialogContent>
                <Typography>
                    {(translateMessage === undefined || translateMessage === true) ? t(message) : message}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button
                    style={{ backgroundColor: '#F5B7B1' }}
                    onClick={() => handleClose(false)}
                    disableFocusRipple={false}
                >
                    {t('cancel')}
                </Button>
                <Button
                    style={{ backgroundColor: '#82E0AA' }}
                    onClick={() => handleClose(true)}
                >
                    {t('confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}